import { Component, OnInit } from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcReport} from '../../report-service.service';
import {ExcFileItem} from '../../attachments/models/ExcFileItem';
import {DataImportUploadConfirmModalComponent} from '../../data-import-upload-confirm-modal/data-import-upload-confirm-modal.component';

@Component({
  selector: 'app-modal-report-edit',
  templateUrl: './modal-report-edit.component.html',
  styles: []
})
export class ModalReportEditComponent extends ExcTranslation implements OnInit {
  private originalReport: ExcReport = null;
  private report: ExcReport = null;
  delivery = {Mail: false, Download: false};
  format = {Original: false, Pdf: false};
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
  }

  ngOnInit() {
    this.originalReport = this.overlayConfig.data.Report.Clone();
    this.initData();
  }
  initData() {
    this.report = this.originalReport.Clone();
    if (this.report.rptOutputFormats.indexOf('pdf') > -1) {
      this.format.Pdf = true;
    }
    if (this.report.rptOutputFormats.toLowerCase().indexOf(this.report.rptTemplateType.toLowerCase()) > -1) {
      this.format.Original = true;
    }
    if (this.report.rptDelivery.toLowerCase().indexOf('mail') > -1) {
      this.delivery.Mail = true;
    }
    if (this.report.rptDelivery.toLowerCase().indexOf('download') > -1) {
      this.delivery.Download = true;
    }
  }
  proceed() {
    const obj = {
      proceed: true,
      rptName: this.report.rptName,
      rptDescription: this.report.rptDescription,
      rptDelivery: '',
      rptOutputFormats: ''
    };
    if (this.format.Pdf) {
      obj.rptOutputFormats = 'pdf';
    }
    if (this.format.Original) {
      if (obj.rptOutputFormats.length > 0) {
        obj.rptOutputFormats += '|';
      }
      obj.rptOutputFormats += this.report.rptTemplateType;
    }
    if (this.delivery.Mail) {
      obj.rptDelivery = 'mail';
    }
    if (this.delivery.Download) {
      if (obj.rptDelivery.length > 0) {
        obj.rptDelivery += '|';
      }
      obj.rptDelivery += 'download';
    }
    this.overlayRef.close(obj);
  }
}
